import React from "react";
import classNames from "classnames";
import "./Panel.scss";
import PanelButton from "../PanelButton";
import Collapse from "react-bootstrap/Collapse";

const Panel = props => {
    let mainClassName = classNames({
        "panel-container":
            !!props.left || !!props.center || !!props.right ? false : true,
        "panel-container-left": !!props.left ? true : false,
        "panel-container-center": !!props.center ? true : false,
        "panel-container-right": !!props.right ? true : false,
        "darker": !!props.alternateBackground,
    });

    let titleClassName = classNames({
        "panel-title": true,
        "title-visible": !!props.title,
        "title-hidden": !props.title,
    });

    let workspaceClassName = classNames({
        "panel-workspace": true,
        "panel-grid": !!props.hasGrid,
        "darker": !!props.alternateBackground,
    });

    let lineclassName = classNames({
        "panel-title-line": !!props.title,
        "panel-title-line-hidden": !props.collapsed,
        "panel-title-line-center": !!props.centered,
    });


    return (
        <div className={mainClassName}>
            <div className={titleClassName}>
                <div className={lineclassName}>
                    {props.title}
                    <PanelButton
                        id={props.id}
                        onClick={props.onClick}
                        collapsed={props.collapsed}
                        title={props.title}
                    />
                </div>
            </div>
            <Collapse in={props.collapsed}>
                <div id={props.id}>
                    {!props.hasGrid ? (
                        <div className={workspaceClassName}>
                            {props.children}
                        </div>
                    ) : (
                        props.children
                    )}
                </div>
            </Collapse>
        </div>
    );
};

export default Panel;
